import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { DropdownItem, PixelPlaceholderLoader } from "@similarweb/ui-components";

import type { EnrichmentType } from "app/pages/sales-intelligence/modules/enrichment/types/types";

export const StyledModalBody = styled.div<{ type: EnrichmentType }>`
    overflow-y: scroll;
    padding: 16px 24px 4px;
    min-height: 332px;
    max-height: 567px;

    ${({ type = "company" }) =>
        type !== "company" &&
        css`
            padding-bottom: 42px;
        `}
`;

export const StyledDownloadEnrichedContainer = styled.div`
    display: flex;
    width: 720px;
    flex-direction: column;
`;
export const StyledModalHeader = styled.div`
    display: flex;
    padding: 0 20px;
    height: 63px;
    background-color: ${colorsPalettes.carbon[0]};
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    justify-content: space-between;
    align-items: center;
`;

export const StyledHeaderText = styled.div`
    ${setFontVariant("h5")};
    text-overflow: ellipsis;
    max-width: 600px;
    overflow: hidden;
    max-height: 48px;
    white-space: nowrap;
`;

export const StyledDropdownSection = styled.div<{ withBorder?: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: flex-start;
    margin-bottom: 16px;
    ${({ withBorder }) =>
        withBorder &&
        css`
            border-bottom: 1px solid ${colorsPalettes.carbon[50]};
            padding-bottom: 8px;
            margin-bottom: 20px;
        `}
`;

export const StyledDropdownWrapper = styled.div<{ marginBottom?: string }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: ${({ marginBottom }) => marginBottom || "0"};
    & .DropdownButton {
        background-color: ${colorsPalettes.carbon[0]};
    }
`;

export const StyledHelpText = styled.div`
    margin-bottom: 8px;
    ${setFontVariant("body1")}
`;

export const StyledTitle = styled.div`
    margin: 31px 0 16px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])}
`;

export const StyledDomainDropdownWrapper = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: center;

    & > div {
        width: auto !important;
        display: flex;
        align-items: center;
        ${setFontVariant("body1", colorsPalettes.carbon[200])}
    }
`;

export const StyledExampleDomains = styled.div`
    margin-left: 16px;
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledColumnPickerSection = styled.div<{ type: EnrichmentType }>`
    display: flex;
    flex-direction: column;

    ${({ type }) =>
        type === "company"
            ? css`
                  margin-top: 32px;
                  min-height: 260px;
              `
            : css`
                  margin-top: 16px;
              `}
`;

export const StyledButtonGroup = styled.div`
    display: flex;
    flex-direction: row;

    & .cancel {
        margin-right: 10px;
    }
`;

export const StyledNumberOfAddedFields = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
`;

export const StyledModalFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: ${colorsPalettes.carbon[0]};
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    padding: 20px 16px 20px 24px;
    border-radius: 0 0 4px 4px;
`;

export const StyledFieldsWrapper = styled.div`
    margin-top: 8px;
`;

export const StyledDropdownItem = styled(DropdownItem)`
    position: relative;
    width: 500px;

    ${({ disabled }) =>
        disabled &&
        css`
            pointer-events: visible;
            opacity: 0.5;
        `};
`;

export const StyledTextWrapper = styled.div`
    position: relative;
    width: 50%;
    color: ${colorsPalettes.carbon[400]};
`;

export const StyledReplaceWrapper = styled.div`
    position: relative;

    & .replaceWrapper {
        & div.SWReactIcons {
            height: 40px;
            width: 40px;
        }
    }
`;

export const ErrorContainer = styled.div`
    flex-direction: column;
    width: 500px;
    text-align: center;
    padding: 20px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${setFontVariant("subTitle3", colorsPalettes.carbon[400])}
`;

export const StyledPixelPlaceholderLoader = styled(PixelPlaceholderLoader)`
    padding: 15px 0;
`;

export const StyledWrappedPreview = styled.div<{ isOutOfQuota?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;

    ${setFontVariant("body1", colorsPalettes.carbon[400])}

    ${({ isOutOfQuota }) =>
        isOutOfQuota &&
        css`
            color: ${colorsPalettes.red["s100"]};
        `}
`;

export const StyledCountriesWrapper = styled.div`
    position: relative;
    display: flex;
    width: fit-content;
`;

export const StyledIconWrapper = styled.div`
    margin-left: 8px;
    position: relative;
`;
